import React from "react"

function GenericNotFound() {
  return (
    <div>404 Sorry, the page you are looking for does not exist</div>
  )
}

export default GenericNotFound